'use client'

// import { Button } from '@/components/ui/button'
// import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { CareShareFundInfo } from './care-share-fund-info'
import { CareAndShareContainer } from './container'

export const CareShareActivities = () => {
  const t = useTranslations()

  return (
    <>
      <CareAndShareContainer>
        <CareShareFundInfo />
        <h2 className='mb-4 mt-10 text-center font-criteria text-lg font-medium uppercase leading-6 text-neutral-900 lg:mb-8 lg:text-4xl lg:leading-13'>
          {t('care_and_share_hardcode.fund_activities.statement.title')}
        </h2>
        <div className='no-scrollbar max-h-[700px] overflow-y-auto overflow-x-hidden rounded-[32px] border-2 border-neutral-200 lg:mx-auto'>
          <iframe
            src='https://thiennguyen.app/doi-tac/minh-bach-tai-khoan/1089'
            width='100%'
            height='700'
            className='w-full rounded-[32px] border-0'
            title={t(
              'care_and_share_hardcode.fund_activities.statement.image_alt'
            )}
            loading='lazy'
            allow='fullscreen'
          />
        </div>

        {/* <Button
          className='mx-auto mt-6 flex w-fit justify-center'
          asChild
          size={'small'}
        >
          <Link
            href={'https://thiennguyen.app/user/caresharewithcoolmate'}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t(
              'care_and_share_hardcode.fund_activities.statement.view_report_button'
            )}
          </Link>
        </Button> */}
      </CareAndShareContainer>
    </>
  )
}
